<template>
  <p>
    Not a member yet? Create an account
    <nuxt-link to="/register"> here</nuxt-link>
  </p>
</template>
<script>
</script>
